import { Component, OnInit, ChangeDetectorRef, inject, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/services/admin.service';
import { Router } from '@angular/router';
import { groupMemberDetails, groupMemberStudyDetails, StudyNote } from 'src/app/model/participant.model';
import { DatePipe } from '@angular/common';
import { Function } from 'src/Utilities/enum';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { AppService } from 'src/app/app.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GroupMemberAuditHistoryModel } from 'src/app/model/group-member-auditdetails.model';
import { ParticipantService } from 'src/services/participant.service';
import { ExcelExportService } from 'src/app/service/excel-export.service';
import { ExportEvent } from 'src/app/shared/dynamic-table/dynamic-table.model';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { DynamicTableComponent } from 'src/app/shared/dynamic-table/dynamic-table.component';
import { SharedDatepickerComponent } from 'src/app/shared/shared-datepicker/shared-datepicker.component';
import { DateHelper, StringHelper } from 'src/Utilities/utility';
import { DefaultValues} from 'src/app/Constant';

@Component({
  selector: 'app-group-member-details',
  templateUrl: './group-member-details.component.html',
  styleUrls: ['./group-member-details.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS,DynamicTableComponent,SharedDatepickerComponent]
})
export class GroupMemberDetailsComponent implements OnInit, AfterViewInit {
  stringHelper = StringHelper;
  groupmemberId: number = 0;
  groupmemberDetails: groupMemberDetails = {} as groupMemberDetails;
  initialGroupmemberDetails: groupMemberDetails = {} as groupMemberDetails;
  groupmemberStudyXrefList: groupMemberStudyDetails[] = [];
  auditParticipants: GroupMemberAuditHistoryModel[] = [];
  dynamicColumns: any[] = [];
  tableConfig: any;
  studyColumns: any[] = [];
  studyTableConfig: any;
  cellTemplates: { [field: string]: TemplateRef<any> } = {};

  @ViewChild('studyNumberTemplate', { static: false }) studyNumberTemplate: TemplateRef<any>;
  isCollapsed: boolean = true;
  disableRowSelection: boolean = true;
  isAuditLoading: boolean = true;
  isStudyLoading: boolean = false;

  isSection1Collapsed: boolean = false;
  isSection2Collapsed: boolean = false;
  isSection3Collapsed = true;

  minDate: Date = new Date(1900, 0, 1);
  maxDate: Date = new Date();

  currentUserId: string;
  currentDate: string;
  dobChecked: boolean = true;
  dobTouched: boolean = false;
  newgid: string
  showSecondSection = false;
  studyNoteDetails: StudyNote[] = [];
  participantId: number = 0;
  showValidationMessage: boolean = false;
  private destroy$ = new Subject<void>();
  readyDatePicker = false; 

  private readonly authStore = inject(AuthStore);

  get gridEnabled(): boolean {
    return this.authStore.isVisible(Function.EditApplicant);
  }

  get isEditable(): boolean {
    return this.authStore.isVisible(Function.EditGroupMember);    
  }

  constructor(
    private route: ActivatedRoute,
    private admin: AdminService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private exportExcel: ExcelExportService
  ) { }

  private deferUiUpdate(updateFn: () => void): void {
    Promise.resolve().then(() => {
      updateFn();
      this.cdr.markForCheck();
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const id = params.get('groupMemberId');

      if (!id || id === 'null' || id === '0') {
        this.generateParticipantId();
        this.initializeGroupMemberDetails();
        this.showSecondSection = false;
        this.groupmemberStudyXrefList = [];
      } else {
        this.groupmemberId = +id;
        this.loadParticipantData();
        this.showSecondSection = true;
        this.loadGroupMemberStudies();
      }

      this.appService.currentUserId$.subscribe(id => {
        this.currentUserId = id;
      });

      let datePipe = new DatePipe('en-US');
      this.currentDate = datePipe.transform(new Date(), 'dd/MMM/yyyy') || '';


      this.setupAuditTrailTable();
      this.setupStudyTable();
      this.loadFullAuditHistory(this.groupmemberId);      

    });
  }

  ngAfterViewInit() {
    // Register cell templates for custom column rendering
    setTimeout(() => {
      if (this.studyNumberTemplate) {
        this.cellTemplates['StudyNumber'] = this.studyNumberTemplate;
      }
      this.readyDatePicker = true;
      this.cdr.detectChanges();
    }, 0);
  }

  private initializeGroupMemberDetails(): void {
    this.groupmemberDetails = {
      groupMemberId: Number(this.newgid),
      participantId: 0,
      firstName: '',
      middleInitial: '',
      lastName: '',
      emailId: '',
      phone: '',
      dob: '',
      applicantStatusId: null,
      mailingStreetAddress: '',
      aptSuiteUnit: '',
      city: '',
      state: '',
      ZipCode: '',
      country: DefaultValues.USA
    } as groupMemberDetails;
    this.initialGroupmemberDetails = { ...this.groupmemberDetails };
  } 

  generateParticipantId(): void {
    this.admin.getNextParticipantId()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: string) => {
          // Remove quotes and convert to number
          this.newgid = response.replace(/"/g, '');
          this.groupmemberDetails.groupMemberId = Number(this.newgid); // store as number
          this.initialGroupmemberDetails = { ...this.groupmemberDetails };
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error generating participant ID:', error);
        }
      });
  }

  
  get groupMemberIdDisplay(): string {
    return this.groupmemberDetails.groupMemberId != null
      ? this.groupmemberDetails.groupMemberId.toString().padStart(6, '0')
      : '';
  }

  set groupMemberIdDisplay(val: string) {
    this.groupmemberDetails.groupMemberId = Number(val.replace(/^0+/, '')) || 0;
  }

  loadParticipantData() {
    let datePipe = new DatePipe('en-US');

    this.admin.getGroupMemberDetails(this.groupmemberId).subscribe(response => {
      const members = Array.isArray(response) ? response : [response];
      const mapped = members.map(member => ({
        groupMemberId: member.groupMemberId,
        participantId: member.participantId || 0,
        firstName: member.firstName || '',
        middleInitial: member.middleInitial || '',
        lastName: member.lastName || '',
        emailId: member.emailId || '',
        phone: member.phone || '',
        dob: DateHelper.toDateOnlyDisplay(member.dob),
        mailingStreetAddress: member.mailingStreetAddress || '',
        aptSuiteUnit: member.aptSuiteUnit || '',
        city: member.city || '',
        state: member.state || '',
        ZipCode: member.ZipCode || '',
        country: (member.country || '').trim() || DefaultValues.USA,
      }));
      this.deferUiUpdate(() => {
        this.participantId = members[0].ParticipantId || 0;
        this.groupmemberDetails = mapped[0];
      });
    }, error => {
      console.error('Error loading group member details:', error);
      alert('Failed to load participant details. Please try again.');
    });
  }

  loadGroupMemberStudies() {
    this.isStudyLoading = true;
    this.admin.getGroupMemberStudyXrefDetails(this.groupmemberId).subscribe(response => {
      const mappedStudies = (Array.isArray(response) ? response : [response]).map(item => ({
        ...item,
        StatusDate: item.StatusDate ? DateHelper.formatDateToDDMMMYYYY(new Date(item.StatusDate)) : null,
        ScreenDate: item.ScreenDate ? DateHelper.formatDateToDDMMMYYYY(new Date(item.ScreenDate)) : null,
        EnrollmentDate: item.EnrollmentDate ? DateHelper.formatDateToDDMMMYYYY(new Date(item.EnrollmentDate)) : null,
        icfVersionDate: item.icfVersionDate ? DateHelper.formatDateToDDMMMYYYY(new Date(item.icfVersionDate)) : null,
        ScheduledDate: item.ScheduledDate ? DateHelper.formatDateToDDMMMYYYY(new Date(item.ScheduledDate)) : null
      }));

      this.deferUiUpdate(() => {
        this.groupmemberStudyXrefList = mappedStudies;
        this.isStudyLoading = false;
      });
    }, error => {
      console.error('Error loading group member study xref details:', error);
      this.deferUiUpdate(() => {
        this.isStudyLoading = false;
      });
    });
  }


  middleInitialOnly(event: KeyboardEvent) {
    let char = event.key;
    if (!/^[a-zA-Z-]$/.test(char)) {
      event.preventDefault();
    }
  }

  validateDate() {
    this.dobTouched = true;
    const dob = this.groupmemberDetails?.dob;
    if (!dob) {
      this.dobChecked = true;
      return;
    }
    const dobDate = new Date(dob);
    if (Number.isNaN(dobDate.getTime()) || dobDate < this.minDate || dobDate > this.maxDate) {
      this.dobChecked = false;
    } else {
      this.dobChecked = true;
    }
  }

  formatPhoneNumber(event: Event): void {
    let input = event.target as HTMLInputElement;
    let numbers = input.value.replace(/\D/g, '');
    if (numbers.length > 10) {
      numbers = numbers.substring(0, 10);
    }
    let formatted = '';
    if (numbers.length > 0) {
      formatted = numbers.substring(0, 3);
      if (numbers.length > 3) {
        formatted += '-' + numbers.substring(3, 6);
      }
      if (numbers.length > 6) {
        formatted += '-' + numbers.substring(6, 10);
      }
    }
    if (this.groupmemberDetails) {
      this.groupmemberDetails.phone = formatted;
    }
    input.value = formatted;
  }

  onlyNumberKey(event: KeyboardEvent): boolean {
    let charCode = event.which ? event.which : event.keyCode;
    return charCode >= 48 && charCode <= 57;
  }

  alphaOnly(event: KeyboardEvent): void {
    let char = event.key;
    const input = event.target as HTMLInputElement;
    if (char === ' ' && (!input?.value || input.value.trim().length === 0)) {
      event.preventDefault();
      return;
    }
    if (!/^[a-zA-Z ]$/.test(char)) {
      event.preventDefault();
    }
  }

  isEmailInvalid(): boolean {
    const email = this.groupmemberDetails?.emailId;
    return !!email && !/^[a-zA-Z0-9.\-_]+@[a-zA-Z.\-]+\.[a-zA-Z]{2,}$/.test(email);
  }

  private validateRequiredGroupMemberFields(): boolean {
    const details = this.groupmemberDetails || {} as groupMemberDetails;
    if (
      !details.firstName ||
      !details.middleInitial ||
      !details.lastName ||
      !details.dob
    ) {
      return false;
    }
    if (this.isEmailInvalid()) {
      return false;
    }
    return true;
  }

  savegroupmemberDetails() {
    this.showValidationMessage = false;
    if (!this.validateRequiredGroupMemberFields()) {
      this.showValidationMessage = true;
      return;
    }
    else {
      this.showValidationMessage = false;
    }

    this.groupmemberDetails.CreatedBy = this.currentUserId;
    this.groupmemberDetails.CreatedOn = new Date();
    this.groupmemberDetails.ModifiedBy = this.currentUserId;
    this.groupmemberDetails.ModifiedOn = new Date();
    let detailsToSave: groupMemberDetails = {
      ...this.groupmemberDetails, dob: DateHelper.toDateOnlyDisplay(this.groupmemberDetails.dob)

    };

    this.admin.postUpdategroupMemberDetails(detailsToSave).subscribe(response => {
      alert('Participant details updated successfully.');
      this.router.navigate(['/adminhome/group-member-details', response]);
      this.loadFullAuditHistory(this.groupmemberId);
    }, error => {
      console.error('Error updating participant details:', error);
      alert('Failed to update participant details. Please try again.');
    });
  }

  loadFullAuditHistory(groupmemberId: number): void {
    this.isAuditLoading = true;
    this.cdr.detectChanges();
    this.admin.GetGroupMemberAuditChanges(groupmemberId).subscribe(
      (result: GroupMemberAuditHistoryModel[]) => {
        const mappedAudit = (Array.isArray(result) ? result : []).map(item => ({
          ...item,
          ModifiedOn: item.ModifiedOn ? this.stringHelper.changeToCSTFormat(new Date(item.ModifiedOn)) : item.ModifiedOn
        }));
        this.deferUiUpdate(() => {
          this.auditParticipants = mappedAudit;
          this.isAuditLoading = false;
        });
      },
      (error) => {
        console.error('Error fetching audit history:', error);
        this.deferUiUpdate(() => {
          this.isAuditLoading = false;
        });
      }
    );
  }

  setupAuditTrailTable() {
    this.tableConfig = {
      rows: 50,
      selectable: false,
      selectionMode: 'single',
      globalSearch: false,
      exportable: true,
      deletable: false,
      lazy: false,
      dataKey: 'GroupMemberAudit',
      preferenceKey: 'GroupMemberAudit',
      supportFilterHierarchy: false,
      title: '',
      columnFilteringEnabled: false,
      addable: false,
      showPagination: true

    };

    this.dynamicColumns = [
      { field: 'Action', header: 'Action performed', width: '70px', sortable: false },
      { field: 'ModifiedOn', header: 'Modified On', width: '70px', sortable: false },
      { field: 'ModifiedBy', header: 'Modified By', width: '70px', sortable: false },
      { field: 'ColName', header: 'Field Name', width: '100px', sortable: false },
      { field: 'PrevValue', header: 'Previous Value', width: '150px', sortable: false },
      { field: 'NewValue', header: 'Updated Value', width: '150px', sortable: false },
    ];
  }

  setupStudyTable() {
    this.studyTableConfig = {
      rows: 50,
      selectable: false,
      selectionMode: 'single',
      globalSearch: false,
      exportable: true,
      deletable: false,
      lazy: false,
      dataKey: 'GroupMemberStudy',
      preferenceKey: 'GroupMemberStudy',
      supportFilterHierarchy: false,
      title: '',
      columnFilteringEnabled: false,
      addable: false,
      showPagination: false
    };

    this.studyColumns = [
      { field: 'StudyNumber', header: 'Study Number', width: '100px', sortable: false, customTemplate: 'StudyNumber' },
      { field: 'StatusName', header: 'Status', width: '100px', sortable: false },
      { field: 'screeningNumber', header: 'Screening Number', width: '120px', sortable: false },
      { field: 'ScreenDate', header: 'Screening Date', width: '120px', sortable: false, dataType: 'date', dateFormat: 'MM/dd/yyyy' },
      { field: 'enrollmentNumber', header: 'Enrollment Number', width: '120px', sortable: false },
      { field: 'EnrollmentDate', header: 'Enrollment Date', width: '120px', sortable: false, dataType: 'date', dateFormat: 'MM/dd/yyyy' },
      { field: 'statusReason', header: 'Status Reason', width: '120px', sortable: false },
      { field: 'StatusDate', header: 'Status Date', width: '120px', sortable: false, dataType: 'date', dateFormat: 'MM/dd/yyyy' },
      { field: 'studyNote', header: 'Study Note', width: '150px', sortable: false, wrap: true }
    ];
  }

  onStudyFilterChange(event: any) {
    console.log('Study filter change:', event);
  }

  onStudyFilterOptionsRefresh(event: any) {
    console.log('Study filter options refresh:', event);
  }

  onStudyExport(event: ExportEvent): void {
    this.exportStudyDataAsXLSX();
  }

  exportStudyDataAsXLSX(): void {
    let datePipe = new DatePipe('en-US');
    let studyExportData: any[] = [];

    if (this.groupmemberStudyXrefList && this.groupmemberStudyXrefList.length > 0) {
      this.groupmemberStudyXrefList.forEach(study => {
        studyExportData.push({
          'Study Number': study.StudyNumber || '',
          'Status': study.StatusName || '',
          'Screening Number': study.screeningNumber || '',
          'Screening Date': study.ScreenDate ? datePipe.transform(study.ScreenDate, 'MM/dd/yyyy') : '',
          'Enrollment Number': study.enrollmentNumber || '',
          'Enrollment Date': study.EnrollmentDate ? datePipe.transform(study.EnrollmentDate, 'MM/dd/yyyy') : '',
          'Status Reason': study.statusReason || '',
          'Status Date': study.StatusDate ? datePipe.transform(study.StatusDate, 'MM/dd/yyyy') : '',
          'Study Note': study.studyNote || ''
        });
      });

      const fileName = `Study_Information_${this.groupmemberDetails.firstName}_${this.groupmemberDetails.lastName}_${datePipe.transform(new Date(), 'yyyyMMdd')}`;
      this.exportExcel.exportAsExcelFile(studyExportData, fileName);
    } else {
      alert('No study information data to export.');
    }
  }

  onStudyPageChange(event: any) {
    console.log('Study page change:', event);
  }

  onStudySelectionChange(event: any) {
    console.log('Study selection change:', event);
  }

  onDynamicFilterChange(event: any) {
    console.log('Audit filter change:', event);
  }

  onDynamicFilterOptionsRefresh(event: any) {
    console.log('Audit filter options refresh:', event);
  }

  onDynamicExport(event: any) {
    let auditParticipantsExportBySp = [];
    if (this.auditParticipants.length) {
      this.auditParticipants.forEach(audit => {
        let participantDetail: any = {
          'Action Performed': audit.Action || '',
          'Modified On': audit.ModifiedOn ? this.stringHelper.changeToCSTFormat(new Date(audit.ModifiedOn)) : audit.ModifiedOn,
          'Modified By': audit.ModifiedBy || '',
          'Field Name': audit.ColName || '',
          'Previous Value': audit.PrevValue || '',
          'Updated Value': audit.NewValue || ''
        };
        auditParticipantsExportBySp.push(participantDetail);
      });

      setTimeout(() => {
        this.exportExcel.exportAsExcelFile(auditParticipantsExportBySp, 'Audit_GroupMember');
      }, 1000);
    } else {
      alert('No Audit participants found.');
    }
  }

  onDynamicPageChange(event: any) {
    console.log('Audit page change:', event);
  }

  onDynamicSelectionChange(event: any) {
    console.log('Audit selection change:', event);
  }

  resetForm() {
    this.groupmemberDetails = { ...this.initialGroupmemberDetails };
    if (!this.groupmemberDetails.country) {
      this.groupmemberDetails.country = DefaultValues.USA;
    }
    this.showValidationMessage = false;
    this.dobTouched = false;
    this.dobChecked = true;
  } 
  
}
